export const TAG_SEPARATOR = {
	COMMA: ',',
	HASHTAG: '#',
};
